import { render, staticRenderFns } from "./aProduct.vue?vue&type=template&id=18aca083&scoped=true"
import script from "./aProduct.vue?vue&type=script&lang=js"
export * from "./aProduct.vue?vue&type=script&lang=js"
import style0 from "./aProduct.vue?vue&type=style&index=0&id=18aca083&prod&lang=scss"
import style1 from "./aProduct.vue?vue&type=style&index=1&id=18aca083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aca083",
  null
  
)

export default component.exports